import { render, staticRenderFns } from "./rechargeRecord.vue?vue&type=template&id=22b7241e&scoped=true&"
import script from "./rechargeRecord.vue?vue&type=script&lang=js&"
export * from "./rechargeRecord.vue?vue&type=script&lang=js&"
import style0 from "./rechargeRecord.vue?vue&type=style&index=0&id=22b7241e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b7241e",
  null
  
)

export default component.exports